import HeroSection from './components/HeroSection'
import FeaturesSection from './components/FeaturesSection'
import AppsSection from './components/AppsSection'
import StatsSection from './components/StatsSection'
import TestimonialsSection from './components/TestimonialsSection'
import CTASection from './components/CTASection'

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <FeaturesSection />
      <AppsSection />
      <StatsSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  )
}

export default Home
